import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import store from './store';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
// import 'antd/dist/antd.css';
import './index.css';
import './generated.css';
import './fontawesome';
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth';
import { stripeKey } from './env';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import './.well-known/apple-developer-merchantid-domain-association';

const firebaseConfig = {
  apiKey: 'AIzaSyB2EetJdF3WwZwHxF7vrctdP4PxM8WaHJw',
  authDomain: 'tabletab-763b6.firebaseapp.com',
  projectId: 'tabletab-763b6',
  storageBucket: 'tabletab-763b6.appspot.com',
  messagingSenderId: '698286649033',
  appId: '1:698286649033:web:4764d385bc75e5d856e718',
  measurementId: 'G-H18KDR5FZ9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

setPersistence(getAuth(app), browserLocalPersistence)
  .then(function () {})
  .catch(function (error) {});

export const stripePromise = loadStripe(stripeKey);
const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Provider store={store}>
        <Elements stripe={stripePromise}>
          <App />
        </Elements>
      </Provider>
    </React.StrictMode>
  </BrowserRouter>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
